var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.open != null)?_c('ExpansionPanels',{attrs:{"items":_vm.items,"recommend":_vm.recommend,"open":_vm.open,"showDescn":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }